__webpack_require__.hmrF = function() { return "heartbeat-monitor." + __webpack_require__.h() + ".hot-update.json"; };